const getOrganizationSlug = () =>
    window.location.href.split('//')[1].split('.')[0];
export default getOrganizationSlug;
